<template>
    <content-string-edit v-if="content" :content="content" :back-route="{ name: 'client-content-strings', params: { clientId: clientId } }" />
</template>
<script>
import contentService from '../../../../../services/content.service'

import ContentStringEdit from '../../../../common/content/string/content-string-edit.vue'

export default {
    name: 'system-content-strings-edit',
    components: { ContentStringEdit },
    data() {
        return {
            content: null
        }
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        contentId() {
            return this.$route.params.contentId;
        }
    },
    async created() {
        this.content = await contentService.getString(this.contentId);
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/content/strings/edit.vue